<template>
  <v-container>
    <h1 class="display-1 pt-3">Analytics {{ name ? `for ${name}` : "" }}</h1>
    <v-row>
      <v-col class="col-12 col-sm-6 col-md-4 col-lg-4">
        <!-- Completion Rate -->
        <a-complete-card :course="courseid" />
      </v-col>
      <v-col class="col-12 col-sm-6 col-md-4 col-lg-4"
        ><a-response-card :course="courseid" />
      </v-col>
      <v-col class="col-12 col-sm-6 col-md-4 col-lg-4"
        ><a-accuracy-card :course="courseid" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 col-lg-12 col-xl-12">
        <v-card elevation="0" :loading="isLoading" flat="" outlined="">
          <v-card-title>Activation / Enrollment</v-card-title>
          <v-card-subtitle class="pb-0"
            >Activation is based on users that have taken 1 or more days of the
            course. Enrollment is the total number of users who enrolled in
            course, regardless of activation.
          </v-card-subtitle>
          <a-metrics
            :course="courseid"
            height="400px"
            @loading="
              status => {
                isLoading = status;
              }
            "
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped></style>
<script>
import metricsseries from "@/components/analytics/metrics-series";
import completeCard from "@/components/analytics/completionrate";
import responseCard from "@/components/analytics/responserate";
import accuracyCard from "@/components/analytics/accuracyrate";
import recents from "@/bin/recents";

import services from "@/services/";

export default {
  components: {
    "a-metrics": metricsseries,
    "a-complete-card": completeCard,
    "a-response-card": responseCard,
    "a-accuracy-card": accuracyCard
  },
  props: ["courseid"],
  data: () => ({
    isLoading: false,
    course: null
  }),
  computed: {
    permissions() {
      if (Array.isArray(this.$store.getters.getUser.permissions)) {
        return this.$store.getters.getUser.permissions;
      } else {
        return [];
      }
    },
    name() {
      if (!this.course || !this.course.name) {
        return "";
      } else {
        return String(this.course.name).trim();
      }
    }
  },
  methods: {
    async onLoad() {
      if (!this.courseid) {
        return;
      }
      try {
        let course = await services.course.getOne({
          type: "publisher",
          id: this.courseid
        });
        this.course = course;
        recents.addToRecents({
          name: `Analytics for ${this.course.name}`,
          path: window.location.href
        });
      } catch (err) {
        console.error(err);
      }
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>

<style></style>
